import metrics from './metrics'

// eslint-disable-next-line import/prefer-default-export
export const defaultMetricsPositions = Object.values(metrics).reduce(
  (acc, item) => ({ ...acc, [item.apiValue]: item.defaultPosition }),
  {},
)
